import React from "react";
import { Button, Image, SafeArea } from "antd-mobile";
import styles from "./index.module.less";
import { FC } from "react";
import { useDocumentTitle } from "~src/hooks/useDocumentTitle";
import { useNavigate } from "react-router-dom";
import { game_home_title } from "~src/assets/images/answerGame";
import useSendCurrentPagePath from "~src/hooks/useSendCurrentPagePath";



const AnswerHome: FC = () => {
  const navigate = useNavigate()
  useDocumentTitle("答题赢大奖")
  const {sendMessage} = useSendCurrentPagePath()
  sendMessage({
    title: "和绿喵一起涨知识，答对4题赢低碳惊喜好礼",
    type: "share",
    path: "",
    shareQuery: "&share=true&type=token",
    selfQuery: "&share=true&type=token"
  })
  const onStartAnser = () => {
    navigate("/answer/question", { replace: true })
  }
  return <div className={styles.answer}>
    <Image src={game_home_title} />
    <div className={styles["answer-content"]}>
      <div className={styles["answer-content-item"]}>
        <div className={styles["answer-content-item-label"]}>共有题目</div>
        <div className={styles["answer-content-item-value"]}>
          <span className={styles["answer-content-item-value-num"]}>4</span>
          <span>道题</span>
        </div>
      </div>
      <div className={styles["answer-content-item"]}>
        <div className={styles["answer-content-item-label"]}>预计占用</div>
        <div className={styles["answer-content-item-value"]}>
          <span className={styles["answer-content-item-value-num"]}>1</span>
          <span>分钟</span>
        </div>
      </div>
    </div>
    <div className={styles["answer-footer"]}>
      <Button className={styles["answer-btn"]} loading={false} disabled={false} loadingText='正在加载' onClick={onStartAnser}>开始闯关</Button>
    </div>
    <SafeArea position="bottom" />
  </div>
}
export default AnswerHome